import styled, { createGlobalStyle } from '@app/styled';
import { spacing } from '@app/theme';

export const Container = styled.div`
    display: grid;
    grid-template-columns: 20px 1fr;
    gap: ${spacing(2)};
    align-items: center;
    background-color: #dedbba;
    padding: ${spacing(3, 4)};
`;

export const AuthToastGlobalStyle = createGlobalStyle`
  .Toastify__close-button {
    display: none !important;
  }
  
  .Toastify__toast {
    background-color: #dedbba !important;
  }
  
  .Toastify__toast {
    padding: 0 !important;
  }
`;

export const SuccessIcon = styled.img`
    width: 20px;
    height: 20px;
`;

export const Text = styled.span`
    font-size: 15px;
    line-height: 20px;
    color: #000000;
`;
